import { useState, useEffect } from 'react';

const useSettings = () => {
  const [settings, setSettings] = useState({
    theme: 'light',
    direction: 'ltr',
    colorTheme: 'Blue_Theme',
    container: 'full',
    sidebarType: 'full',
    cardWith: 'border'
  });

  useEffect(() => {
    const savedSettings = localStorage.getItem('app-settings');
    if (savedSettings) {
      const parsedSettings = JSON.parse(savedSettings);
      setSettings(parsedSettings);
      applySettings(parsedSettings);
    } else {
      applySettings(settings);
    }
  }, []);

  const applySettings = (settingsToApply) => {
    // Theme
    if (settingsToApply.theme === 'dark') {
      document.body.classList.add('dark');
      document.documentElement.setAttribute('data-bs-theme', 'dark');
    } else {
      document.body.classList.remove('dark');
      document.documentElement.setAttribute('data-bs-theme', 'light');
    }

    // Direction
    document.documentElement.setAttribute('dir', settingsToApply.direction);

    // Color Theme
    document.documentElement.setAttribute('data-color-theme', settingsToApply.colorTheme);
    document.body.className = document.body.className.replace(/\btheme-\w+/g, '');
    const themeName = settingsToApply.colorTheme.split('_')[0].toLowerCase();
    document.body.classList.add(`theme-${themeName}`);

    // Container
    const wrapper = document.querySelector('.body-wrapper');
    if (wrapper) {
      wrapper.classList.toggle('container', settingsToApply.container === 'boxed');
    }

    // Sidebar Type
    const sidebar = document.querySelector('.left-sidebar');
    const logo = document.querySelector('.brand-logo');
    if (sidebar) sidebar.classList.toggle('mini-sidebar', settingsToApply.sidebarType === 'mini');
    if (logo) logo.classList.toggle('mini-logo', settingsToApply.sidebarType === 'mini');

    // Card Style
    document.querySelectorAll('.card').forEach(card => {
      card.classList.toggle('card-border', settingsToApply.cardWith === 'border');
      card.classList.toggle('card-shadow', settingsToApply.cardWith === 'shadow');
    });
  };

  const updateSetting = (key, value) => {
    const newSettings = { ...settings, [key]: value };
    setSettings(newSettings);
    localStorage.setItem('app-settings', JSON.stringify(newSettings));
    applySettings(newSettings);
  };

  const handleColorTheme = (theme) => {
    updateSetting('colorTheme', theme);
  };

  return {
    settings,
    updateSetting,
    handleColorTheme
  };
};

export default useSettings;
